import { Loader2 } from "lucide-react"
import type { LoadingOverlayProps } from "../../types/components"

export const LoadingOverlay = ({ message }: LoadingOverlayProps) => (
  <div className="absolute inset-0 bg-white/80 backdrop-blur-sm z-50 flex items-center justify-center">
    <div className="flex flex-col items-center gap-3">
      <Loader2 className="w-8 h-8 animate-spin text-blue-600" />
      <p className="text-sm font-medium text-gray-700">{message}</p>
    </div>
  </div>
)
